/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCapitol: {
  name: 'capitol';
  data: string;
} = {
  name: 'capitol',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M599.02 301.357v-62.413H460.862c-9.664-69.076-64.303-123.726-133.376-133.406l-21.968-82.349-21.969 82.35c-69.071 9.681-123.709 64.33-133.373 133.405H12.013v62.413h62.294v212.534H12.013v62.413h218.489l-15.339 27.482h182.223l-15.551-27.482H599.02v-62.413h-62.198V301.357h62.198zM327.59 513.733h-44.049V301.357h44.049v212.376zM156.899 301.357h44.05v212.534h-44.05V301.357zM454.23 513.891h-44.048V301.357h44.048v212.534z"/></svg>`,
};
